import type { TOC } from '@ember/component/template-only';
import PageError from '../components/page-error.gts';

interface Signature {
  Args: {};
}

const ApplicationError: TOC<Signature> = <template>
  <PageError
    @title="Failed to load"
    @message="Something went wrong while loading the application. Please try again."
  />
</template>;

export default ApplicationError;
